import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAwsamplifyComponent } from './simple-icons-awsamplify.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAwsamplifyComponent ],
    exports:      [ SimpleIconsAwsamplifyComponent ],
    bootstrap:    []
})
export class SimpleIconsAwsamplifyModule {}
